export interface StampPreviewResult {
  currentFilled: number
  previewFilled: number
  rewardsUnlocked: number
  carryOver: number
}

export function calculateStampPreview(
  currentStamps: number,
  stampsToAdd: number,
  stampTarget: number,
): StampPreviewResult {
  const totalAfter = currentStamps + stampsToAdd
  const rewardsUnlocked = Math.floor(totalAfter / stampTarget)
  const carryOver = totalAfter % stampTarget
  const previewFilled = Math.min(stampsToAdd, stampTarget - currentStamps)

  return { currentFilled: currentStamps, previewFilled, rewardsUnlocked, carryOver }
}
